import axios from './http'
import { format } from 'path'
const api = {
  //权限管理
  base: {
    logout: params =>
      axios.get('/logout', {
        params: params
      }),
    menu: () => axios.get('/menu/queryPageByOther'),
    userInfo: () => axios.get('/user/getCurrentUser'),
    fileUpload: 'fileSplitter/upLoad',
    index: () => axios.get('/menu/queryHomeIndex')
  },
  //
  report: {
    reportTypeList: params => axios.get('/report/queryByClassCode', { params }),
    reportSubmit: formata => axios.post('/report/submit', formata),
    // 宏鹄工作台
    reportHonghu: formata => axios.post('/report/honghu', formata)
  },
  authCode: {
    pin: params => axios.get('/pin/getPin', { params }),
    sms: formata => axios.post('/pin/sendSms', formata)
  },
  faq: {
    faqList: params => axios.get('/faqs/queryPage', { params }),
    faqDetail: params => axios.get('/faqs/detail', { params })
  },
  article: {
    articleList: params => axios.get('/article/queryPage', { params }),
    articleDetail: params => axios.get('/article/detail', { params })
  },
  illegalInfo: {
    company: formata => axios.post('/company/queryDiscreditList', formata),
    person: formata => axios.post('/person/queryDiscreditList', formata)
  }
}

export default api



// WEBPACK FOOTER //
// ./src/api/api.js